import useQuizQuestion from 'hooks/API/GET/useQuizQuestion';
import useManageQuizQuestion from 'hooks/API/useManageQuizQuestion';
import useToaster from 'hooks/useToaster';
import { useParams } from 'react-router-dom';

function useSource({ paperId }) {
  const { quizID, courseID, chapterID, questionID } = useParams();
  const manageQuizQuestion = useManageQuizQuestion({
    quizID,
    courseID,
    chapterID,
  });
  const quizQuestion = useQuizQuestion({
    enabled: !!(quizID && courseID && chapterID && questionID),
    quizID,
    courseID,
    chapterID,
    questionID,
    configs: { params: { paperId } },
  });

  useToaster(manageQuizQuestion.isLoading, {
    type: manageQuizQuestion.isError ? 'error' : 'success',
  });

  return {
    manageQuizQuestion,
    quizQuestion,
  };
}

export default useSource;
